import { useQuery } from '@tanstack/react-query'

import { useCartStore } from '@/stores/cart-store/cartStore'

import { getHolidays } from '../api/getHolidays'

export const useHolidays = () => {
	const { federalState } = useCartStore.use.travelPeriod()

	return useQuery({
		queryKey: ['GET_HOLIDAYS', federalState],
		queryFn: () => getHolidays(federalState!),
		enabled: Boolean(federalState),
		staleTime: Infinity,
	})
}
